// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23QQi","icon":"styles_icon__2BSIA"};